export class EnvironmentSettings {
  public static HTTP_DP_API_DEV_ROOT =
    "https://gyx7k26ozk.execute-api.eu-central-1.amazonaws.com/development";
  public static HTTP_DP_API_PROD_ROOT =
    "https://gyx7k26ozk.execute-api.eu-central-1.amazonaws.com";
  public static HTTP_DP_API_DEV_SERVER =
    "https://gyx7k26ozk.execute-api.eu-central-1.amazonaws.com/development/anaci/data";
  public static HTTP_DP_API_PROD_SERVER =
    "https://gyx7k26ozk.execute-api.eu-central-1.amazonaws.com/anaci/data";
  public static ANACI_PLATFORM_AUTH = "/anaci/platform-auth";
  public static ANACI_PLATFORM_BUILDING = "/anaci/platform-building";
  public static ANACI_PLATFORM_PRODUCT = "/anaci/platform-product";
  public static ANACI_PLATFORM_USER = "/anaci/platform-user";
  public static ANACI_PLATFORM_QUOTE = "/anaci/platform-quote";
  public static ANACI_WS_HOST_NAME_DEV = "anacidevws.bigstudio.cloud";
  public static ANACI_WS_HOST_NAME_PROD = "anaciprodws.bigstudio.cloud"; //d22s591kn006yq.cloudfront.net
  public static ANACI_WS_PORT_DEV = "443";
  public static ANACI_WS_PORT_PROD = "443"; //443
  public static COOKIEBOT_DEV_CBID = "370fa8a4-d417-483f-9c92-2a8504d13319";
  public static COOKIEBOT_PROD_CBID = "3c2f48e9-6566-40fb-863c-a487997dabfb";
  public static BILL_AWS_FOLDER_DEV = "bills-dev";
  public static QUOTE_AWS_FOLDER_DEV = "quotes-dev";
  public static BILL_AWS_FOLDER_PROD = "bills";
  public static QUOTE_AWS_FOLDER_PROD = "quotes";
  public static ANACI_SERVER_ENDPOINT_DEV = "185.170.213.146";
  public static ANACI_SERVER_ENDPOINT_PROD = "194.99.20.163";
  public static API_ICON_REPOSITORY =
    "https://gyx7k26ozk.execute-api.eu-central-1.amazonaws.com/icon/";
}
